




































































































































/** @format */
import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import AddEditModal from './components/add-edit-model.vue';
import { SaleStatusMap } from '@/types/package-management/dictionaries';
import Utils from '@/utils/common';
import OrganizationSearch from '@/components/organization-search/index.vue';
import moment from 'moment';
import {
  merchantPackageRecordList,
  merchantPackageRecordExport,
  merchantPackageDelete
} from '@/api/package-management/index';
@Component({
  name: 'PackageManagement',
  components: { ParkingLotSearch, AddEditModal, OrganizationSearch }
})
export default class PackageManagement extends Mixins(TableMixin, TableWidthMixin) {
  private filterParam: any = {
    payChannel: '',
    merchantPackageName: '',
    orgDepId: '',
    merchantName: '',
    expirationStartDate: '',
    expirationEndDate: '',
    paidStartTime: '',
    paidEndTime: ''
  };
  // options = Utils.toLabelVal(businessTypeMap)
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_merc_type);
  businessType = ''; //商户类型
  // orgdepId = ''
  private tableLoading: boolean = false;
  editModel: boolean = false; //弹出框是否显示
  tableData: any[] = [];
  isEdit: boolean = false;
  addEditModalData: any = null;
  saleStatusList: any[] = Utils.toLabelVal(SaleStatusMap) || [];
  canExport: boolean = true;
  isOrgRoot: boolean = true;
  isDetail: boolean = false;
  payChannelMethodList: any[] = [{ label: '线上购买', value: '00' }, { label: '线下购买', value: '01' }];
  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '所属机构（项目）',
        dataIndex: 'orgName',
        width: 180
      },
      {
        title: '所属商家',
        dataIndex: 'merchantName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '优惠类型',
        dataIndex: 'packageType',
        width: 180,
        scopedSlots: { customRender: 'packageType' }
      },
      {
        title: '套餐名称',
        dataIndex: 'packageName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '套餐面额',
        dataIndex: 'quotaStr',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '购买数量',
        dataIndex: 'paidNum',
        width: 180
      },
      {
        title: '结算价（元）',
        dataIndex: 'paidAmount',
        width: 180
      },

      {
        title: '套餐失效日期',
        dataIndex: 'expirationDate',
        width: 200
      },
      {
        title: '购买时间',
        dataIndex: 'paidTime',
        width: 200
      },
      {
        title: '购买方式',
        dataIndex: 'buyType',
        width: 180
      },
      {
        title: '操作人',
        dataIndex: 'operater',
        width: 200
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 160,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  //table初始化
  current = 1;
  pageSize = 10;
  private moment = moment;
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { ...rest } = this.filterParam;
      const { status, code, msg, data } = await merchantPackageRecordList({
        ...rest,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //搜索时间配置
  private onTimeChange(date: any, dateString: any) {
    const [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.paidStartTime = operateTimeStart;
    this.filterParam.paidEndTime = operateTimeEnd;
  }
  get defaultTime() {
    if (this.filterParam.paidStartTime && this.filterParam.paidEndTime) {
      return [
        this.moment(this.filterParam.paidStartTime, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.paidEndTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.paidStartTime) {
      return [this.moment(this.filterParam.paidStartTime, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  //搜索时间配置
  private onTimeChange1(date: any, dateString: any) {
    const [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.expirationStartDate = operateTimeStart;
    this.filterParam.expirationEndDate = operateTimeEnd;
  }
  get expiresTime() {
    if (this.filterParam.expirationStartDate && this.filterParam.expirationEndDate) {
      return [
        this.moment(this.filterParam.expirationStartDate, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.expirationEndDate, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.expirationStartDate) {
      return [this.moment(this.filterParam.expirationStartDate, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  set expiresTime(val: any) {}
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear() {
    this.filterParam = {
      payChannel: '',
      merchantPackageName: '',
      orgDepId: '',
      merchantName: '',
      expirationStartDate: '',
      expirationEndDate: '',
      paidStartTime: '',
      paidEndTime: ''
    };
    (this.$refs.orgTree as any).setRootId();
    this.searchTable();
  }
  //新增 修改
  async editItem(val?: any, flag?: any) {
    if (val) {
      this.addEditModalData = { ...val };
    }
    this.isEdit = val ? true : false;
    this.isDetail = flag ? true : false;
    this.editModel = true;
  }
  //删除
  deleteItem(val: any) {
    console.log(val);
    const that = this;
    this.$confirm({
      title: '提示',
      content: `确定要删除购买的套餐吗？`,
      async onOk() {
        try {
          const { status, msg, code, data } = await merchantPackageDelete({
            id: val.id
          });
          if (status === '9999') {
            that.$message.success('删除成功');
            that.fetchTableData();
          } else {
            that.$message.error(msg ? msg : '删除失败');
          }
        } catch (e) {
          console.log(e);
          that.$message.error((e && e.msg) || '删除失败');
        }
      },
      onCancel() {}
    });
  }
  //弹窗取消
  handleModalCancel() {
    this.editModel = false;
  }
  //弹窗保存
  handleModalCreate() {
    this.editModel = false;
    this.fetchTableData(true);
  }
  //默认选中机构根节点
  selectDefaultRoot(val: any) {
    this.filterParam.orgDepId = val;
  }
  //导出
  private async downLoad() {
    try {
      const { ...rest } = this.filterParam;
      this.canExport = false;
      this.canExport = true;
      await merchantPackageRecordExport(
        {
          ...rest,
          currPage: this.current,
          pageSize: this.pageSize
        },
        '套餐销售管理'
      );
    } catch (e) {
      this.canExport = true;
      console.log('couponExport', '导出失败');
    }
  }
  //获取当前时间
  get currentTime() {
    return moment(new Date()).format('YYYY-MM-DD');
  }
  created() {
    this.$nextTick(() => {
      this.fetchTableData();
    });
    console.log(this.currentTime);
  }
}
